import { render, staticRenderFns } from "./godine.editor.vue?vue&type=template&id=948628ae&scoped=true&"
import script from "./godine.editor.vue?vue&type=script&lang=ts&"
export * from "./godine.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948628ae",
  null
  
)

export default component.exports